// "Preview new screens" (apps/pipeline_api/src/preview.rs). The server decides: gated routes answer
// 403 `preview_required` without it. This only drives what the UI shows.
import { useMeQuery } from "./queries";
import type { Me, PreviewState } from "./types";

const OFF: PreviewState = { available: false, enabled: false, on: false, triage: false };

export function previewOf(me: Me | undefined | null): PreviewState {
  return me?.user.preview ?? OFF;
}

/** Preview is on for this session. */
export function previewOn(me: Me | undefined | null): boolean {
  return previewOf(me).on;
}

/** The session's Preview state; off outside the signed-in shell. */
export function usePreview(): PreviewState {
  return previewOf(useMeQuery().data);
}
